import { render, staticRenderFns } from "./TeamFeed.vue?vue&type=template&id=f849bb40&scoped=true&"
import script from "./TeamFeed.vue?vue&type=script&lang=js&"
export * from "./TeamFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f849bb40",
  null
  
)

export default component.exports